import { Controller } from "@hotwired/stimulus"

// Fires one anonymous, cookie-free page-view beacon per page load; see PageViewsController's
// own comment for what this deliberately doesn't send (no cookie, no session id, nothing that
// identifies a visitor across page loads). Only ever attached on marketing pages (see
// application.html.erb), and only runs at all for a client that actually executes JavaScript,
// which already rules out the vast majority of bot/crawler traffic without any filtering logic
// here.
export default class extends Controller {
  connect() {
    if (navigator.doNotTrack === "1") return

    const body = new URLSearchParams({
      path: location.pathname,
      referrer: document.referrer
    })

    // sendBeacon is the right tool here specifically because it survives the page unloading:
    // a fetch() started right before navigation can get cancelled mid-flight, silently dropping
    // the beacon for anyone who clicks through fast. Falls back to a keepalive fetch only for a
    // browser old enough not to have sendBeacon at all.
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/page_views", new Blob([ body ], { type: "application/x-www-form-urlencoded" }))
    } else {
      fetch("/page_views", { method: "POST", body, keepalive: true })
    }
  }
}
